<template>
<div class="chapter">
<div class="inner_page">
<div class="image-break">
<p class="image"><img alt="Images" src="images/P6.jpg"/></p>
<p class="caption">The author in front of the Cecil Hotel. <i>Author’s collection.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page6.vue?37a2fbd2